
import { supabase } from './supabase';

export interface User {
  id: string;
  email: string;
  role: 'admin' | 'distributor' | 'user';
}

export async function signIn(email: string, password: string) {
  const { data, error } = await supabase.auth.signInWithPassword({
    email,
    password,
  });
  
  if (error) throw error;
  return data;
}

export async function signUp(email: string, password: string) {
  const { data, error } = await supabase.auth.signUp({
    email,
    password,
  });
  
  if (error) throw error;
  return data;
}

export async function signOut() {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
}

export async function getCurrentUser() {
  const { data: { user } } = await supabase.auth.getUser();
  return user;
}

export async function checkIsAdmin(userId: string): Promise<boolean> {
  const { data } = await supabase
    .from('admin_users')
    .select('id')
    .eq('user_id', userId)
    .maybeSingle();
  
  return !!data;
}

export async function checkIsDistributor(userId: string): Promise<boolean> {
  const { data } = await supabase
    .from('distributor_users')
    .select('id')
    .eq('user_id', userId)
    .eq('is_active', true)
    .maybeSingle();
  
  return !!data;
}

export async function getUserRole(userId: string): Promise<'admin' | 'distributor' | 'user'> {
  const isAdmin = await checkIsAdmin(userId);
  if (isAdmin) return 'admin';
  
  const isDistributor = await checkIsDistributor(userId);
  if (isDistributor) return 'distributor';
  
  return 'user';
}
